module.exports = {
  reqProductInfoUrl: '/web/v1/product/info', // 获取产品信息
  reqUnionRecommendUrl: '/web/v1/recommend/union-promotion', // 获取联报推荐
  reqCouponInfoUrl: '/web/v1/coupon/link', // 获取优惠券信息
  reqReceiveCouponUrl: '/web/v1/coupon/get', // 领取优惠券
  reqReceivebatchCouponUrl: '/web/v1/coupon/batch/get', // 批量领取优惠券
  reqCheckCouponUrl: '/web/v1/coupon/check/coupon', // 校验用户是否领取过
  reqOrderPriceInfoUrl: '/web/v1/price', // 获取促销活动
  orderCommitUrl: '/web/v1/order/commit', // 提交订单
  reqCashierInfoUrl: '/web/v1/pay/cashier-desk-info', // 收银台初始化
  reqHuabeiInfoUrl: '/web/v1/pay/hb-payable', // 获取花呗详细分期信息
  reqCheckOrderProductUrl: '/web/v1/order/check/product', // 订单商品校验
  reqOrderValidationUrl: '/web/v1/pay/pay-verify', // 订单校验
  reqPayImmediateUrl: '/web/v1/pay/immediate-payment', // 立即支付
  reqPaySuccessInfoUrl: '/web/v1/pay/success/info', // 获取订单支付成功页信息
  reqServiceTimeUrl: '/ref/v1/system/currentTime', // 获取服务器时间
  reqAddressListUrl: '/web/v1/user/address/list', // 获取用户地址列表
  reqUserOrderCouponListUrl: '/web/v1/coupon/available/coupons', // 获取用户下单优惠券列表
  reqPayResultUrl: '/web/v1/pay/pay-result', // 查询支付状态
  reqCourseStartStatusUrl: '/web/v1/user/course/check', // 查询开课状态

  reqReturnCashierInfoUrl: '/web/v1/pay/change-cashier', // 退换课 收银台初始化
  reqReturnPayImmediateUrl: '/web/v1/pay/change-pay', // 退换课 立即支付
  reqReturnPayResultUrl: '/web/v1/pay/query-change', // 退换课 查询支付状态

};
